const templateQuestions = [
  {
    subject: "GCSE Maths",
    topic: "Algebra",
    subtopic: "Expanding Brackets",
    type: "template",
    template: "\\[ {{expression}} \\]",
    variables: {
      a: [2, 3, 4],
      b: [1, 2, 3, 4, 5],
      c: [1, 2, 3, 4],
      d: [1, 2, 3, 4, 5],
    },
    generate: ({ a, b, c, d }, i) => {
      let expression = "";
      let answer = "";

      const simplifyExpression = (raw) => {
        return raw
          .replace(/([a-z])\1/g, "$1^2")                 // xx -> x^2
          .replace(/([a-z])([a-z])/g, (match, a, b) =>
            a < b ? `${a}${b}` : `${b}${a}`               // yx -> xy
          )
          .replace(/\+ -/g, "- ")                         // Clean "+ -" to "-"
          .replace(/(^|\s)1(?=[a-z])/g, "$1");            // Remove 1 before variables
      };

      if (i < 3) {
        expression = `${a}(x + ${b})`;
        answer = `${a}x + ${a * b}`;
      } else if (i < 6) {
        const filteredB = [3, 4, 5, 6, 7, 8, 9, 10];
        b = filteredB[Math.floor(Math.random() * filteredB.length)];
        expression = `${a}(${b}x - ${c})`;
        answer = `${a * b}x - ${a * c}`;
      } else if (i < 9) {
        const filteredB = [2, 3, 4, 5];
        b = filteredB[Math.floor(Math.random() * filteredB.length)];
        expression = `${a}x(${b}x + ${c})`;
        answer = `${a * b}x^2 + ${a * c}x`;
      } else if (i < 11) {
        const filteredA = [2, 3, 4];
        const filteredB = [2, 3, 4];
        const filteredC = [2, 3, 4];
        a = filteredA[Math.floor(Math.random() * filteredA.length)];
        b = filteredB[Math.floor(Math.random() * filteredB.length)];
        c = filteredC[Math.floor(Math.random() * filteredC.length)];
        expression = `${a}xy(${b}x + ${c}y)`;
        answer = `${a * b}x^2y + ${a * c}xy^2`;
      } else if (i < 15) {
        const filteredA = [2, 3, 4];
        const filteredB = [2, 3, 4];
        const filteredC = [2, 3, 4];
        const filteredM = [2, 3, 4];
        const filteredN = [2, 3, 4];
        const filteredO = [2, 3, 4];
        const filteredP = [2, 3, 4];
        a = filteredA[Math.floor(Math.random() * filteredA.length)];
        b = filteredB[Math.floor(Math.random() * filteredB.length)];
        c = filteredC[Math.floor(Math.random() * filteredC.length)];
        const m = filteredM[Math.floor(Math.random() * filteredM.length)];
        const n = filteredN[Math.floor(Math.random() * filteredN.length)];
        const o = filteredO[Math.floor(Math.random() * filteredO.length)];
        const p = filteredP[Math.floor(Math.random() * filteredP.length)];
        expression = `${a}x^${m}y^${n}(${b}x^${o} + ${c}y^${p})`;
        answer = `${a * b}x^${m + o} + ${a * c}y^${n + p}`;
      } else if (i < 21) {
        const sign1 = Math.random() < 0.5 ? "+" : "-";
        const sign2 = Math.random() < 0.5 ? "+" : "-";
        const b1 = sign1 === "+" ? b : -b;
        const d1 = sign2 === "+" ? d : -d;
        expression = `${a}(x ${sign1} ${Math.abs(b1)}) + ${c}(x ${sign2} ${Math.abs(d1)})`;
        const ax = a + c;
        const constant = a * b1 + c * d1;
        answer = simplifyExpression(`${ax}x + ${constant}`);
      } else if (i < 25) {
        const sign1 = Math.random() < 0.5 ? "+" : "-";
        const sign2 = Math.random() < 0.5 ? "+" : "-";
        const b2 = sign1 === "+" ? b : -b;
        const d2 = sign2 === "+" ? d : -d;
        expression = `${a}(x ${sign1} ${Math.abs(b2)}) - ${c}(x ${sign2} ${Math.abs(d2)})`;
        const ax = a - c;
        const constant = a * b2 - c * d2;
        answer = simplifyExpression(`${ax}x + ${constant}`);
      } else {
        const terms = ["x", "y", "xy"];
        const outer1 = terms[Math.floor(Math.random() * terms.length)];
        const outer2 = terms[Math.floor(Math.random() * terms.length)];
        const coef1 = a;
        const coef2 = c;
        const sign1 = Math.random() < 0.5 ? "+" : "-";
        const sign2 = Math.random() < 0.5 ? "+" : "-";
        const inner1 = `${sign1} ${b}`;
        const inner2 = `${sign2} ${d}`;

        const expanded1 = `${coef1}${outer1}(x ${inner1})`;
        const expanded2 = `${coef2}${outer2}(x ${inner2})`;
        expression = `${expanded1} + ${expanded2}`;

        const expandBracket = (coef, outer, sign, value) => {
          const inner = sign === "+" ? value : -value;
          const terms = [];
          for (let char of outer) {
            terms.push(`${coef}${char}x`);
            terms.push(`${coef * inner}${char}`);
          }
          return terms;
        };

        const terms1 = expandBracket(coef1, outer1, sign1, b);
        const terms2 = expandBracket(coef2, outer2, sign2, d);
        const rawAnswer = [...terms1, ...terms2].join(" + ");
        answer = simplifyExpression(rawAnswer);
      }

      const instruction = i >= 15 ? "Expand and simplify:" : "Expand:";

      return {
        expression,
        answer,
        textLines: [instruction, `\\( ${expression} \\)`],
      };
    },
  },
];

export default templateQuestions;
